export const getSessionKey = (key,defaultValue)=>{
  const item = window.sessionStorage.getItem(key);
  if(item == undefined && defaultValue != undefined){
    return defaultValue;
  }
  return item;
}

const farmatDate = (dataStr) =>{
	if(!dataStr){
		return;
	}
    let year = dataStr.substr(0,4);
    let month = dataStr.substr(5,2);
    let day = dataStr.substr(8,2);
    var fmt = '';
    if(year){
       fmt=year;
    }
    if(month){
        fmt += '-'+month;
    }
    if(day){
        fmt += '-'+day;
    }
    return fmt;
}
const farmatUpdateDate = (dataStr) =>{
	if(!dataStr){
		return;
	}
    let year = dataStr.substr(0,4);
    let month = dataStr.substr(4,2);
    let day = dataStr.substr(6);
    var fmt = '';
    if(year){
       fmt=year;
    }
    if(month){
        fmt += '-'+month;
    }
    if(day){
        fmt += '-'+day;
    }
    return fmt;
}
function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
export {farmatDate, farmatUpdateDate,dateFormat}


// WEBPACK FOOTER //
// ./src/common/utils.js